<div class="booking-container" [class.onew-way-trip]="isOneWayTripType$ | async">
  <ng-container *ngIf="showBookingHeader$ | async">
    <ng-container *ngTemplateOutlet="bookingHeader"></ng-container>
  </ng-container>
  <ng-container *ngIf="(isLoadingBookingBody$ | async) === false; else bookingPlaceholder">
    <ng-container *ngTemplateOutlet="bookingBody"></ng-container>
  </ng-container>
</div>

<ng-template #bookingHeader>
  <div class="modal-bg" (click)="toggleBookingDetail()" [class.active]="showBookingDetail"></div>
  <div class="bookingContainer__header">
    <app-ds-typography
      [tag]="'h3'"
      [size]="fontSize.Smaller"
      [fontFamily]="fontFamily.SemiBold"
      [color]="fontColor.Secondary"
      [text]="('BOOKING_MODULE.COMPLETE_RESERVATION' | transloco) | uppercase">
    </app-ds-typography>
    <app-ds-typography
      [tag]="'h1'"
      [size]="fontSize.MD"
      [fontFamily]="fontFamily.SemiBold"
      [color]="fontColor.Primary"
      [text]="'BOOKING_MODULE.ADD_YOUR_CONTACT_DETAILS' | transloco">
    </app-ds-typography>
    <div class="bookingContainer__header-back">
      <app-ds-button
        [type]="secondaryButtonType"
        [showIcon]="true"
        [icon]="icons.ChevronLeft"
        [labels]="{ ButtonLabel: 'BACK' | transloco }"
        (clickEvent)="goBack()">
      </app-ds-button>
    </div>
  </div>
</ng-template>

<ng-template #bookingPlaceholder>
  <ng-container *ngIf="isMobile$ | async; else desktopPlaceholder">
    <ng-container *ngIf="isLoggedIn$ | async">
      <app-travel-loader></app-travel-loader>
    </ng-container>
  </ng-container>
  <ng-template #desktopPlaceholder>
    <div class="container">
      <div class="booking-body">
        <div class="booking-form-info">
          <app-booking-placeholders></app-booking-placeholders>
        </div>
        <div class="placeholder-payment-detail">
          <app-payment-detail-loading></app-payment-detail-loading>
        </div>
      </div>
    </div>
  </ng-template>
</ng-template>

<ng-template #bookingBody>
  <ng-container [ngSwitch]="travelType">
    <ng-container *ngSwitchCase="travelBookingType.AUTOS">
      <ng-container *ngTemplateOutlet="bookingAutos"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="travelBookingType.BUSES">
      <ng-container *ngTemplateOutlet="bookingBuses"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="travelBookingType.FLIGHTS">
      <ng-container *ngTemplateOutlet="bookingFlights"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="travelBookingType.FLIGHTS_BY_SECTOR">
      <ng-container *ngTemplateOutlet="bookingFlightsBySector"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="travelBookingType.HOTELS">
      <ng-container *ngTemplateOutlet="bookingHotels"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="travelBookingType.PACKAGE_AIR">
      <ng-container *ngTemplateOutlet="bookingPackageAir"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="travelBookingType.ACTIVITIES">
      <ng-container *ngTemplateOutlet="bookingActivities"></ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #bookingFlights>
  <app-booking-flights
    [airValidation]="airValidation$ | async"
    [isLoggedIn]="isLoggedIn$ | async"
    [user]="user$ | async"
    [isMobile]="isMobile$ | async"
    [passengerTitleBlock]="passengerTitleBlock">
  </app-booking-flights>
</ng-template>

<ng-template #bookingFlightsBySector>
  <app-booking-flights-by-sector 
    [airValidationBySector]="airValidationBySector$ | async"
    [isLoggedIn]="isLoggedIn$ | async"
    [user]="user$ | async"
    [isMobile]="isMobile$ | async"
    [passengerTitleBlock]="passengerTitleBlock">
  </app-booking-flights-by-sector>
</ng-template>

<ng-template #bookingBuses>
  <app-booking-buses
    [airValidation]="airValidation$ | async"
    [isLoggedIn]="isLoggedIn$ | async"
    [user]="user$ | async"
    [isMobile]="isMobile$ | async">
  </app-booking-buses>
</ng-template>

<ng-template #bookingHotels>
  <app-booking-hotels
    [hotelValidation]="hotelValidation$ | async"
    [isLoggedIn]="isLoggedIn$ | async"
    [user]="user$ | async"
    [isMobile]="isMobile$ | async"
    >
  </app-booking-hotels>
</ng-template>

<ng-template #bookingAutos>
  <app-booking-autos
    [autoValidation]="autoValidation$ | async"
    [companyCode]="companyCode"
    [isLoggedIn]="isLoggedIn$ | async"
    [user]="user$ | async"
    [isMobile]="isMobile$ | async">
  </app-booking-autos>
</ng-template>

<ng-template #bookingPackageAir>
  <app-booking-package-air
    [airValidation]="airValidation$ | async"
    [hotelValidation]="hotelValidation$ | async"
    [isLoggedIn]="isLoggedIn$ | async"
    [user]="user$ | async"
    [isMobile]="isMobile$ | async">
  </app-booking-package-air>
</ng-template>

<ng-template #bookingActivities>
  <app-booking-activities
    [validation]="activitiesValidation$ | async"
    [isLoggedIn]="isLoggedIn$ | async"
    [user]="user$ | async"
    [isMobile]="isMobile$ | async">
  </app-booking-activities>
</ng-template>

<ng-template #passengerTitleBlock>
  <div class="title">
    <app-ds-typography
      [size]="fontSize.XS"
      [color]="fontColor.Primary"
      [fontFamily]="fontFamily.SemiBold"
      [text]="'PASSENGERS' | transloco"
      [tag]="'h3'">
    </app-ds-typography>
  </div>

  <div class="description">
    <app-ds-typography
      [size]="fontSize.XXS"
      [color]="fontColor.Secondary"
      [fontFamily]="fontFamily.Regular"
      [text]="'BOOKING_MODULE.PAX.GENERAL_DESCRIPTION' | transloco"
      [tag]="'p'">
    </app-ds-typography>
  </div>
</ng-template>

<app-booking-alert
  [isMobile]="isMobile$ | async"
  [travelType]="travelType"
  [hotelValidation]="hotelValidation$ | async"
  [validationError]="validationError$ | async">
</app-booking-alert>

<router-outlet></router-outlet>

<router-outlet name="terms"></router-outlet>

<router-outlet name="informative"></router-outlet>

<ng-container *ngIf="(isLoggedIn$ | async) === false">
  <router-outlet name="auth"></router-outlet>
</ng-container>

<ng-template #churningExcededForm let-user='user'>
  <div class="churning-exceded-cont">
    <div class="churning-exceded-support-img">
      <img class="churning-exceded-img" loading="lazy" [alt]="'BOOKING_MODULE.CHURNING_EXCEDED.TITLE' | transloco" [src]="supportImg | ImageCdn">
    </div>
    <div class="churning-exceded-body">
      <h3 class="error-title">{{'BOOKING_MODULE.CHURNING_EXCEDED.TITLE' | transloco}}</h3>
      <p class="error-description">{{'BOOKING_MODULE.CHURNING_EXCEDED.DESCRIPTION' | transloco}}</p>
    </div>
    <div class="churning-exceded-actions">
      <app-ds-button
        [labels]="{ ButtonLabel: 'BOOKING_MODULE.CHURNING_EXCEDED.BTN_USER_HISTORY' | transloco }"
        (clickEvent)="closeAndBackChurningExceded(user)">
      </app-ds-button>
    </div>
    <div class="churning-exceded-actions">
      <div class="close">
        <app-ds-button
          [labels]="{ ButtonLabel: 'BOOKING_MODULE.CHURNING_EXCEDED.GOT_TO_BACK' | transloco }"
          [type]="secondaryButtonType"
          (clickEvent)="closeAndBackChurningExceded(user, true)">
        </app-ds-button>
      </div>
    </div>
  </div>
</ng-template>

<ng-container *ngIf="isMobile$ | async">
  <app-swipe-up
    [height]="95"
    [showSwipeUp]="isChurningExceded$ | async"
    (toggleShowSwipeUp)="onlyCloseChurningExceded()">
    <ng-container content>
      <ng-container *ngTemplateOutlet="churningExcededForm; context: { user: user$ | async }"></ng-container>
    </ng-container>
  </app-swipe-up>
</ng-container>

<ng-container *ngIf="(isMobile$ | async) === false">
  <ng-container *ngIf="isChurningExceded$ | async">
    <app-modal [width]="640">
      <ng-container content>
        <ng-container *ngTemplateOutlet="churningExcededForm; context: { user: user$ | async }"></ng-container>
      </ng-container>
    </app-modal>
  </ng-container>
</ng-container>
